import React from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';

import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { CompanyBranchService } from '../services/CompanyBranches';
import { formatTel } from '../utilities/stringUtil';
import { Modal } from '../components/Modal';
import { DialogSuccessError } from '../components/modals/DialogSuccessError';
import masterSlideLoader from '../utilities/masterSlideLoader';
import UserApi from '../services/user/UserApi';
import UsersApi from '../services/users/UsersApi';
import {
  isTargetRoleId,
  isPrimaryCompanyRoleId,
  isPartnerCompanyRoleId,
  isPartnerRoleId,
} from '../utilities/roleUtility';
import { getOneMasterTypeNameCompanyNumber } from '../utilities/commonUtil';
import { messageUtility } from '../utilities/messageUtility';
import {
  INTEGRATE_USER_COMMON_ERROR_MESSAGE,
  HEADER_CONSTANTS,
  INTEGRATE_USER_SUCCESS_MESSAGE,
  INTEGRATE_USER_SUCCESS_TITLE,
  maxiileSize,
  USER_ROLES,
  USER_VIEW_MODE,
} from '../utilities/constants';
import { MasterPageHeader } from '../components/PageHeader';
import { UserForm } from '../components/UserForm';
import UserService from '../services/user/UserService';
import Information from '../components/modals/common/Information';
import { HEAD_OFFICE_OPTION } from '../components/PartnerCompanyBranchDropdown';
import { ConfirmIntegrateUserDialog } from '../components/modals/ConfirmIntegrateUserDialog';
import { LoginUserGroupsService } from '../services/LoginUserGroups';
import { ConfirmExistedEmailDialog } from '../components/modals/ConfirmExistedEmailDialog';
import { UserService as UserServices } from '../services/Users';
import { IntegrateError } from '../components/modals/IntegrateError';
import EventManager, { EventType } from '../utilities/EventManager';
import { CompanyService } from '../services/Companies';
import RegisteredCompaniesDialog from '../components/modals/RegisteredCompaniesDialog';

/**
 * 新規ユーザー登録画面
 */
export class UserNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validate: {},
      validationMessage: {},
      params: {
        login_id: '',
        user_role_code: null, // ユーザー種別
        buildee_manager_flg: false, // Buildeeマネジャーフラグ
        use_chosei_flg: false, // 調整会議利用権限有無
        use_green_file_flg: false, // 調整会議利用権限有無
        use_nyutaijo_flg: false, // 入退場利用権限有無
        name_sei: '', // 姓
        name_mei: '', // 名
        kana_sei: '', // せい
        kana_mei: '', // めい
        tel: '', // 電話番号
        fax: '', // Fax
        email: '', // ユーザーID(メールアドレス)
        company_branch: null, // 支店
        partner_company_branch: {
          id: HEAD_OFFICE_OPTION.id,
          name: HEAD_OFFICE_OPTION.name,
        },
        image_url: '', // 画像ファイルアイコン
      }, // フォームの値を保持
      dialog_show: false, // ダイアログフラグ
      isMoveToUserPage: false,
      userId: '',
      isPrimary: isPrimaryCompanyRoleId(LocalStorageService.getRoleId()),
      inputCount: 0, // 必須項目入力数
      requiredNumber: 0, // 全必須項目数
      errorDialogFlg: false, //エラーダイアログ表示フラグ
      errorMessage: '', //エラーメッセージ
      isManagerPermission: false,
      hasManagerPermission: true, // 企業管理者がユーザーに存在するかのフラグ
      events: {
        onChange: this.onChange,
        onBlur: this.onBlur,
        back: this.back,
        submit: this.submit,
      },
      isShowPopupConfirmIntegrateUser: false,
      isShowPopupExistedEmail: false,
      isShowPopupIntegrateUserError: false,
      isShowPopupInfo: false,
      isShowRegisteredCompaniesDialog: false,
      userIntegrates: [],
      registeredCompanies: [],
      checkIntegrateError: false,
      messageIntegrate: '',
      isIntegrateSuccess: false,
      popupInfoMessage: '',
    };
    this.isSubmittingFlag = false;

    // slideLoaderからの情報を取得
    if (props.view) {
      this.state.userId = props.view.state.id;
    }

    // 必須項目ステータス
    this.requiredList = {
      user_role_code: true, // ユーザー種別
      name_sei: false, // 性
      name_mei: false, // 名
      kana_sei: false, // せい
      kana_mei: false, // めい
      email: false, // ユーザーID(メールアドレス)
      company_branch_id: false, // 支店
      partner_company_branch_id: false,
    };

    // roleId を保持しておく
    this.roleId = LocalStorageService.getRoleId();
    this.companyId = SessionStorageService.getCompanyId(); // 本社ID
    this.userId = LocalStorageService.getUserId(); // ユーザーID
    this.companyBranchId = SessionStorageService.getCompanyBranchId();
    this.sessionCompanyId = SessionStorageService.getItem(
      'sessionPartnerCompanyIdOfPrimeCompany'
    );
    this.companyName = '';
    this.companyAddress = '';
    this.oneMasterTypeNameCompanyNumber = '';

    this.selfCompanyBranch = null; // 自身の支店情報保持用
    this.partnerCompanyJoiningFlag = SessionStorageService.getPartnerCompanyJoiningFlag();
    this.hasPartnerCompanyBranchDropdown = false;
  }

  async componentDidMount() {
    if (isTargetRoleId([USER_ROLES.branch, USER_ROLES.manager], this.roleId)) {
      this.getCompanyBranch();
    } else if (isPartnerRoleId(this.roleId)) {
      const param = { company_branch_id: this.companyBranchId };
      CompanyBranchService.show(this.companyId, param).then(response => {
        if (response.result) {
          const { company } = response.data.entities;
          this.companyName = _.get(response, 'data.entities.company.name');
          this.companyAddress =
            (company.prefecture_name || '') +
            (company.city_name || '') +
            (company.street_number || '') +
            (company.building_name || '');
          this.oneMasterTypeNameCompanyNumber = getOneMasterTypeNameCompanyNumber(
            company.one_master_flag,
            company.company_number
          );
        }
      });
    }
    await this.settingPermission();
    this.setServicePermissionsInitValue();
    await this.setPartnerCompanyBranchInitValue();
    // 初期値を設定（操作ユーザーと同一が初期値）
    this.onChange('user_role_code', this.roleId);
  }

  setPartnerCompanyBranchInitValue = () => {
    if (
      this.partnerCompanyJoiningFlag &&
      isPartnerCompanyRoleId(this.roleId) &&
      this.state.isManagerPermission
    ) {
      this.hasPartnerCompanyBranchDropdown = true;
      this.requiredList.partner_company_branch_id = true;
      this.setState(prevState => ({
        params: {
          ...prevState.params,
          partner_company_branch_id: HEAD_OFFICE_OPTION.id,
        },
      }));
    } else {
      delete this.requiredList.partner_company_branch_id;
    }
  };

  /**
   * @description 支店情報を取得
   */
  getCompanyBranch = () => {
    CompanyBranchService.companyBranchList().then(response => {
      const params = _.cloneDeep(this.state.params);
      if (response.result) {
        // 自社支店IDを取得
        const company_branch_id = Number(this.companyBranchId);
        const company_branches = response.data.entities.company_branches;
        this.selfCompanyBranch = _.find(company_branches, company_branch => {
          return company_branch_id === company_branch['id'];
        });
        params.company_branch = _.cloneDeep(this.selfCompanyBranch);
        this.setState({ params });
      }
    });
  };

  settingPermission = async () => {
    return UsersApi.fetchCompanyUserPermissions(this.companyId, {
      buildee_manager_flg: 1,
    })
      .then(res => {
        let isManagerPermission = false;
        let hasManagerPermission = true;
        if (res.result === true) {
          if (res.data.total === 0) {
            hasManagerPermission = false;
          } else {
            const companyUserPermissions =
              res.data.entities.company_user_permissions;
            for (let permission of companyUserPermissions) {
              if (permission.user_id === Number(this.userId)) {
                isManagerPermission = true;
                break;
              }
            }
          }

          this.setState({
            isManagerPermission,
            hasManagerPermission,
          });
        } else {
          let errorMessage = '';
          if (res.message) {
            errorMessage = res.message;
          } else {
            errorMessage = res.data.message;
          }
          this.setState({ errorDialogFlg: true, errorMessage });
        }
      })
      .catch(error => {
        let errorMessage = '';
        if (error.message) {
          errorMessage = error.message;
        } else {
          errorMessage = error.data.message;
        }
        this.setState({ errorDialogFlg: true, errorMessage });
      });
  };

  setServicePermissionsInitValue = () => {
    if (this.state.hasManagerPermission) {
      this.setState({
        params: {
          ...this.state.params,
          use_chosei_flg: true,
          use_nyutaijo_flg: true,
        },
      });
    }
  };

  openDialog(isMoveToUserPage) {
    this.setState({
      dialog_show: true,
      isMoveToUserPage,
    });
  }

  /**
   * 利用者詳細に戻る
   * */
  back = () => {
    this.setState({ dialog_show: true });
  };

  /**
   * @description 詳細な相関バリデーションチェック
   * @param {object} params 全入力パラメータ
   * @returns バリデーションチェック後のエラーメッセージオブジェクト
   */
  checkValidate(params) {
    let result = UserService.validate(params, this.state.isPrimary);
    result.messages = result.messages || {};
    if (params.user_image) {
      if (params.user_image.length > maxiileSize) {
        result.status = false;
        result.messages.user_image = '5MB以下の画像にしてください。';
      }
    }

    // 支店_バリデーションチェック
    if (!_.isUndefined(params.user_role_code)) {
      if (
        (isTargetRoleId([USER_ROLES.branch], params.user_role_code) &&
          isTargetRoleId([USER_ROLES.prime], this.roleId)) ||
        (isTargetRoleId([USER_ROLES.manager], params.user_role_code) &&
          isTargetRoleId([USER_ROLES.prime], this.roleId)) ||
        (isTargetRoleId([USER_ROLES.manager], params.user_role_code) &&
          isTargetRoleId([USER_ROLES.branch], this.roleId))
      ) {
        if (!params.company_branch_id) {
          delete params.company_branch_id;
        }
        if (!_.has(params, 'company_branch_id')) {
          result.status = false;
          result.messages.company_branch_id = messageUtility.getMessage(
            'E-000-023',
            '支店'
          );
        }
      }
    }

    return result;
  }

  /**
   * 入力した値を送信する
   */
  submit = async () => {
    const state_params = _.cloneDeep(this.state.params);
    const params = this.createParams(state_params);
    let result = this.checkValidate(params);

    if (result.status) {
      this.setState({ validate: {} });
      if (isPartnerRoleId(params.user_role_code)) {
        return this.checkRegisteredCompanies(params);
      }
      if (await this.checkDuplicateEmail()) {
        this.toggleDialog('isShowPopupExistedEmail', true);
      } else {
        this.runSubmit();
      }
    } else {
      // エラーメッセージを表示
      this.setState({
        validate: result.messages,
        validationMessage: result.messages,
      });
    }
  };

  /**
   * submitの実行
   *
   */
  runSubmit = () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    this.setState({
      isShowPopupConfirmIntegrateUser: false,
      isShowPopupExistedEmail: false,
      isShowPopupIntegrateUserError: false,
      isShowRegisteredCompaniesDialog: false,
    });
    const params = this.handleParam();
    const formData = UserService.createRequestParam(params);
    UserApi.create(formData)
      .then(res => {
        if (res.result === true) {
          this.setState({
            showModal: true,
            updateSuccess: true,
            updateMsg: 'ユーザー登録完了',
            updateMsgDetail: 'ユーザーの登録が完了しました。',
          });

          const jumpTo = () => {
            masterSlideLoader.show('Users', { state: { id: 0 } });
          };
          this.setState({ jumpTo });
        } else {
          let errorMessage = '';
          if (res.message) {
            errorMessage = res.message;
          } else if (res.data.message) {
            errorMessage = res.data.message;
          } else {
            // errorに入ってないときは安全にデフォルトのエラーメッセージ
            errorMessage = messageUtility.getMessage('E-000-001');
          }
          // モーダルの表示(通信エラー)
          this.setState({
            showModal: true,
            updateSuccess: false,
            updateMsg: messageUtility.getMessage('E-001-402'),
            updateMsgDetail: errorMessage,
          });
        }
      })
      .catch(error => {
        let errorMessage = '';
        // errorにちゃんと入ってた場合
        if (error && error.length > 0) {
          errorMessage = error[0].responseJSON.message;
        } else {
          // errorに入ってないときは安全にデフォルトのエラーメッセージ
          errorMessage = messageUtility.getMessage('E-000-001');
        }

        // モーダルの表示(通信エラー)
        this.setState({
          showModal: true,
          updateSuccess: false,
          updateMsg: messageUtility.getMessage('E-001-402'),
          updateMsgDetail: errorMessage,
        });
      })
      .finally(() => {
        this.isSubmittingFlag = false;
      });
  };

  createParams(stateParams) {
    const params = {};
    params.kana_mei = stateParams.kana_mei;
    params.kana_sei = stateParams.kana_sei;
    params.name_sei = stateParams.name_sei;
    params.name_mei = stateParams.name_mei;
    params.user_image = stateParams.image_url;
    params.user_role_code = stateParams.user_role_code;
    params.email = stateParams.email;
    params.tel = formatTel(stateParams.tel);

    // 職長はログインIDがメールではないため
    if (
      this.state.isPrimary === false &&
      isTargetRoleId([USER_ROLES.foreman], params.user_role_code)
    ) {
      params.login_id = stateParams.login_id;
    } else {
      params.login_id = params.email;
    }

    // ユーザー種別が協力会社管理者の場合
    if (isTargetRoleId([USER_ROLES.partner], params.user_role_code)) {
      params.fax = formatTel(stateParams.fax);
    }
    if (this.hasPartnerCompanyBranchDropdown) {
      params.partner_company_branch_id = stateParams.partner_company_branch_id;
    }
    params.company_branch_id = '';
    params.company_id = '';
    if (this.state.isPrimary === false) {
      params.company_id = this.sessionCompanyId;
      params.company_branch_id = this.companyBranchId;
    } else {
      if (!_.isEmpty(stateParams.company_branch)) {
        params.company_branch_id = stateParams.company_branch.id;
      }
    }

    // ユーザー種別が本社管理者の場合
    if (isTargetRoleId([USER_ROLES.prime], params.user_role_code)) {
      params.company_id = this.companyId;
      delete params.company_branch_id;
    }

    if (this.state.isManagerPermission) {
      params.buildee_manager_flg = stateParams.buildee_manager_flg;
      params.use_chosei_flg = stateParams.use_chosei_flg;
      params.use_green_file_flg = stateParams.use_green_file_flg;
      params.use_nyutaijo_flg = stateParams.use_nyutaijo_flg;
    }

    return params;
  }

  onChange = (key, value) => {
    const state_params = _.cloneDeep(this.state.params);
    if (key === 'company_branch') {
      state_params['company_branch_id'] = value.id;
    }

    if (key === 'partner_company_branch') {
      state_params['partner_company_branch_id'] = value.id;
    }

    if (key === 'user_role_code') {
      // ユーザー種別を変更し、ユーザー種別が支店管理者で操作中のユーザのロールも支店管理者の場合
      if (
        isTargetRoleId([USER_ROLES.branch], value) &&
        isTargetRoleId([USER_ROLES.branch], this.roleId)
      ) {
        // 自社ブランチを固定で設定する
        state_params.company_branch = _.cloneDeep(this.selfCompanyBranch);
        state_params.company_branch_id = this.companyBranchId;
      }
    }

    // サービス権限の場合
    if (key === 'permissions') {
      state_params.use_chosei_flg = value.use_chosei_flg;
      state_params.use_green_file_flg = value.use_green_file_flg;
      state_params.use_nyutaijo_flg = value.use_nyutaijo_flg;
    } else {
      state_params[key] = value;
    }

    this.setState({ params: state_params }, () => {
      const params = this.createParams(_.cloneDeep(this.state.params));
      this.setInputInfo(key, params);
    });
  };

  onBlur = key => {
    // バリデーションを実行
    const state_params = _.cloneDeep(this.state.params);
    const params = this.createParams(state_params);
    let validationMessage = _.cloneDeep(this.state.validationMessage);
    let result = this.checkValidate(params);

    if (result.status === false && !_.isEmpty(result.messages[key])) {
      // 入力項目に誤りがある場合、エラーメッセージをセット
      validationMessage[key] = result.messages[key];
    } else {
      // 正常に入力している場合、エラーメッセージを削除
      delete validationMessage[key];
    }
    this.setState({ validationMessage });
  };

  setInputInfo = (key, params) => {
    if (!key) {
      return;
    }

    // 全必須項目数計算
    if (key === 'user_role_code' && !_.isUndefined(params.user_role_code)) {
      if (this.state.isPrimary) {
        if (
          isTargetRoleId([USER_ROLES.prime], params.user_role_code) ||
          (isTargetRoleId([USER_ROLES.branch], params.user_role_code) &&
            isTargetRoleId([USER_ROLES.branch], this.roleId)) ||
          isTargetRoleId([USER_ROLES.manager], this.roleId)
        ) {
          delete this.requiredList.company_branch_id;
        } else {
          if (_.has(params, 'company_branch_id')) {
            this.requiredList.company_branch_id = true;
          } else {
            this.requiredList.company_branch_id = false;
          }
        }
      } else {
        delete this.requiredList.company_branch_id;
      }
    }

    if (
      !this.state.isPrimary &&
      isTargetRoleId([USER_ROLES.foreman], params.user_role_code)
    ) {
      if (_.has(params, 'login_id')) {
        this.requiredList.login_id = true;
      } else {
        this.requiredList.login_id = false;
      }
      delete this.requiredList.email;
    } else {
      if (_.has(params, 'email')) {
        this.requiredList.email = true;
      } else {
        this.requiredList.email = false;
      }
      delete this.requiredList.login_id;
    }
    if (this.hasPartnerCompanyBranchDropdown) {
      this.requiredList.partner_company_branch_id = _.has(
        params,
        'partner_company_branch_id'
      );
    }

    this.setState({ requiredNumber: _.size(this.requiredList) });

    if (key === 'company_branch') {
      key = 'company_branch_id';
    }
    if (key === 'partner_company_branch') {
      key = 'partner_company_branch_id';
    }
    if (_.has(this.requiredList, key)) {
      // 必須項目フォームを操作した場合
      this.requiredList[key] = UserService.isNormalValue(
        params,
        key,
        this.state.isPrimary
      );
      let inputCount = UserService.getFraction(params, this.requiredList);
      if (inputCount !== this.state.inputCount) {
        this.setState({ inputCount });
      }
    }
  };

  closeErrorDialog = () => {
    this.setState({
      errorDialogFlg: false,
    });
  };

  checkIntegrateUser = async () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const params = this.createParams(this.state.params);
    const paramsCheckIntegrate = {
      email: params.email,
      user_role_code: params.user_role_code,
    };
    const companyId = _.get(params, 'company_id');
    const companyBranchId = _.get(params, 'company_branch_id');

    if (companyId) {
      paramsCheckIntegrate.company_id = companyId;
    }
    if (companyBranchId) {
      paramsCheckIntegrate.company_branch_id = companyBranchId;
    }
    const { data, result } = await LoginUserGroupsService.checkIntegrate(
      paramsCheckIntegrate
    );
    this.isSubmittingFlag = false;
    this.toggleDialog('isShowPopupExistedEmail', false);
    if (result) {
      return this.setState({
        userIntegrates: _.get(data, 'entities.users'),
        isShowPopupConfirmIntegrateUser: true,
      });
    }
    this.setState({
      messageIntegrate: _.get(data, 'message'),
      isShowPopupIntegrateUserError: true,
    });
  };

  handleIntegrateUser = async () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const params = this.handleParam();
    const formData = UserService.createRequestParam(params);
    const { result } = await UserServices.createIntegrate(formData);
    this.toggleDialog('isShowPopupConfirmIntegrateUser', false);
    this.isSubmittingFlag = false;
    if (result) {
      EventManager.trigger(EventType.REFRESH_PROFILE);
      return this.setState({
        isIntegrateSuccess: true,
        isShowPopupInfo: true,
        popupInfoMessage: INTEGRATE_USER_SUCCESS_MESSAGE,
      });
    }
    this.setState({
      isIntegrateSuccess: false,
      isShowPopupInfo: true,
      popupInfoMessage: INTEGRATE_USER_COMMON_ERROR_MESSAGE,
    });
  };

  checkDuplicateEmail = async () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const params = this.createParams(this.state.params);
    const paramsCheckEmail = {
      email: params.email,
      user_role_code: params.user_role_code,
    };
    const companyId = _.get(params, 'company_id');
    const companyBranchId = _.get(params, 'company_branch_id');

    if (companyId) {
      paramsCheckEmail.company_id = companyId;
    }
    if (companyBranchId) {
      paramsCheckEmail.company_branch_id = companyBranchId;
    }
    const { result } = await LoginUserGroupsService.checkDuplicateEmail(
      paramsCheckEmail
    );
    this.isSubmittingFlag = false;
    return result;
  };

  toggleDialog = (key, value) => {
    this.setState({ [key]: value }, () => {
      if (this.state.isIntegrateSuccess) {
        masterSlideLoader.show('Users', { state: { id: 0 } });
      }
    });
  };

  handleParam = () => {
    const state_params = _.cloneDeep(this.state.params);
    const params = this.createParams(state_params);

    if (!_.has(params, 'tel')) {
      params.tel = '';
    }
    if (_.size(params.user_image) === 0) {
      params.user_image = '';
    }
    if (
      isTargetRoleId(
        [USER_ROLES.manager, USER_ROLES.foreman],
        params.user_role_code
      )
    ) {
      params.buildee_manager_flg = false;
    }

    const partnerCompanyBranchId = _.get(
      state_params,
      'partner_company_branch_id'
    );
    if (partnerCompanyBranchId) {
      params.partner_company_branch_id =
        partnerCompanyBranchId === HEAD_OFFICE_OPTION.id
          ? ''
          : partnerCompanyBranchId;
    }
    return params;
  };

  checkRegisteredCompanies = values => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    CompanyService.getRegisteredCompanies(values.company_id, {
      company_id: values.company_id,
      email: values.email,
    }).then(async response => {
      this.isSubmittingFlag = false;
      if (response.result) {
        const registeredCompanies = _.get(response, 'data.entities.companies');
        if (_.isEmpty(registeredCompanies)) {
          this.runSubmit();
        } else {
          this.setState({
            registeredCompanies,
            isShowRegisteredCompaniesDialog: true,
          });
        }
      } else {
        if (await this.checkDuplicateEmail()) {
          this.toggleDialog('isShowPopupExistedEmail', true);
        } else {
          this.setState({
            isShowPopupInfo: true,
            popupInfoMessage: _.get(response, 'data.message'),
          });
        }
      }
    }).catch(() => {
      this.isSubmittingFlag = false;
    });
  };

  render() {
    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - ユーザー登録</title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title='新規ユーザー登録'
            onClose={() => this.openDialog(false)}
          />
          <UserForm
            userId={this.state.userId}
            viewMode={USER_VIEW_MODE.NEW}
            isPrimary={this.state.isPrimary}
            params={this.state.params}
            blockPermission={this.state.blockPermission}
            inputCount={this.state.inputCount}
            requiredNumber={this.state.requiredNumber}
            isManagerPermission={this.state.isManagerPermission}
            hasManagerPermission={this.state.hasManagerPermission}
            submit={this.submit}
            events={this.state.events}
            validationMessage={this.state.validationMessage}
          />

          <Information
            message={this.state.errorMessage}
            buttonText={messageUtility.getMessage('I-000-017')}
            visible={this.state.errorDialogFlg}
            onClose={this.closeErrorDialog}
          />

          <Dialog
            state={this.state}
            cancel={() => this.setState({ dialog_show: false })}
          />

          <Modal modalRoot='root' modalState={this.state.showModal}>
            <DialogSuccessError
              msg={this.state.updateMsg}
              msgDetail={this.state.updateMsgDetail}
              updateSuccess={this.state.updateSuccess}
              multilineText={true}
              success={this.state.jumpTo}
              error={() => this.setState({ showModal: false })}
              labelBtnError={messageUtility.getMessage('I-000-017')}
            />
          </Modal>

          <ConfirmExistedEmailDialog
            visible={this.state.isShowPopupExistedEmail}
            userRoleCode={this.state.params.user_role_code}
            onCancel={() => this.toggleDialog('isShowPopupExistedEmail', false)}
            isCreateNew={true}
            onConfirmNotIntegrate={this.runSubmit}
            onConfirmIntegrate={this.checkIntegrateUser}
          />

          <ConfirmIntegrateUserDialog
            visible={this.state.isShowPopupConfirmIntegrateUser}
            onCancel={() =>
              this.toggleDialog('isShowPopupConfirmIntegrateUser', false)
            }
            onConfirm={this.handleIntegrateUser}
            data={this.state.userIntegrates}
          />

          <IntegrateError
            reason={this.state.messageIntegrate}
            visible={this.state.isShowPopupIntegrateUserError}
            userRoleCode={this.state.params.user_role_code}
            onConfirm={this.runSubmit}
            isCreateNew={true}
            onCancel={() =>
              this.toggleDialog('isShowPopupIntegrateUserError', false)
            }
          />

          <Information
            visible={this.state.isShowPopupInfo}
            title={
              this.state.isIntegrateSuccess
                ? INTEGRATE_USER_SUCCESS_TITLE
                : messageUtility.getMessage('E-001-402')
            }
            message={this.state.popupInfoMessage}
            buttonText={messageUtility.getMessage('I-000-017')}
            onClose={() => this.toggleDialog('isShowPopupInfo', false)}
            multilineText={true}
          />
          <RegisteredCompaniesDialog
            visible={this.state.isShowRegisteredCompaniesDialog}
            registeredCompanies={this.state.registeredCompanies}
            companyName={this.companyName}
            companyAddress={this.companyAddress}
            oneMasterTypeNameCompanyNumber={this.oneMasterTypeNameCompanyNumber}
            onConfirm={this.runSubmit}
            onCancel={() =>
              this.toggleDialog('isShowRegisteredCompaniesDialog', false)
            }
          />
        </div>
      </div>
    );
  }
}

/**
 * @description ダイアログ
 * @param {func} cancel 新規ユーザー登録画面(元請)に戻る
 */
const Dialog = ({ state, cancel }) => (
  <div
    id='modal-dialog-confirm-selected'
    className={state.dialog_show ? 'modal show' : 'modal'}
  >
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        {(() => {
          if (state.isMoveToUserPage) {
            return (
              <span className='dialog-md__title'>
                {data.dialog.moveToUsertitle}
              </span>
            );
          } else {
            return (
              <span className='dialog-md__title'>
                {data.dialog.closeEditTitle}
              </span>
            );
          }
        })()}
      </div>
      <div className='dialog-md__body text-left'>
        <p>
          <span className='text--muted'>
            {messageUtility.getMessage('I-000-confirmCloseEditWindow')}
          </span>
        </p>
      </div>
      <div className='dialog-md__footer-horizontal'>
        <button
          id='modal-close-confirm-selected'
          className='btn-fixedsize--sub'
          onClick={cancel}
        >
          {data.dialog.backButtonTitle}
        </button>
        <button
          className='btn-fixedsize--negative'
          onClick={() => {
            masterSlideLoader.show('Users', { state: { id: 0 } });
          }}
        >
          {messageUtility.getMessage('I-000-closeEditWindow')}
        </button>
      </div>
    </div>
  </div>
);

// 定数
const data = {
  dialog: {
    closeEditTitle: '編集画面を閉じる',
    moveToUsertitle: 'ユーザー一覧画面に戻る',
    backButtonTitle: '戻る',
  },
};



// WEBPACK FOOTER //
// ./src/pages/UserNew.jsx